import { ChevronUp, GripVertical, Plus, Trash2 } from "lucide-react";
import React, { useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { TASK_STATUS } from "../Constants";

const SiteTaskCard = ({
  selectedTasks,
  setIsModalOpen,
  setSelectedTasks,
  provided,
  onDragEnd,
  handleDelete,
  isSubtask = false,
}) => {
  const [openMilestone, setOpenMilestone] = useState(null);
  const toggleMilestone = (id) => {
    setOpenMilestone(openMilestone === id ? null : id);
  };

  return (
    <div ref={provided.innerRef} {...provided.droppableProps}>
      <ul className="border-l-2 pl-7 space-y-4">
        {selectedTasks.map((task, index) => (
          <Draggable
            key={task.id}
            draggableId={task.id.toString()}
            index={index}
          >
            {(provided) => (
              <li
                className="relative bg-white max-w-full "
                ref={provided.innerRef}
                {...provided.draggableProps}
              >
                <span
                  className={`absolute -left-12 top-1 bg-gray-400 rounded-full py-1 px-3 border-4 border-white text-md text-white`}
                >
                  {index + 1}
                </span>
                <div className="flex items-center border border-gray-300 rounded-md px-3 py-2 gap-3">
                  <div
                    className={`w-6 flex-shrink-0 flex justify-center ${
                      isSubtask ? "hidden" : "visible"
                    }`}
                  >
                    <ChevronUp
                      className={`${
                        openMilestone === task.id ? "rotate-180" : "rotate-90"
                      } transform transition-transform duration-300 cursor-pointer`}
                      onClick={() => toggleMilestone(task.id)}
                    />
                  </div>

                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold truncate">
                      {task.title}
                    </h3>
                    <p className="text-xs text-gray-600 truncate">
                      {task.description}
                    </p>
                  </div>

                  <div
                    className="w-24 flex-shrink-0 flex justify-end items-center gap-2 cursor-grab"
                    {...provided.dragHandleProps}
                  >
                    <span className="text-sm">{task.weight}</span>
                    <button
                      onClick={() => handleDelete(task.id)}
                      className="p-1 rounded-full hover:bg-red-100 text-red-600"
                    >
                      <Trash2 size={16} />
                    </button>
                    <GripVertical />
                  </div>
                </div>

                {openMilestone === task.id && (
                  <div className="pl-2 mt-3">
                    {task?.sub_tasks?.length > 0 && (
                      <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId={task.id.toString()} type="TASK">
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                              className="pl-2"
                            >
                              <SiteTaskCard
                                selectedTasks={task.sub_tasks}
                                setIsModalOpen={setIsModalOpen}
                                setSelectedTasks={(newSubTasks) =>
                                  setSelectedTasks((prev) =>
                                    prev.map((t) =>
                                      t.id === task.id
                                        ? { ...t, sub_tasks: newSubTasks }
                                        : t
                                    )
                                  )
                                }
                                provided={provided}
                                onDragEnd={onDragEnd}
                                handleDelete={handleDelete}
                                isSubtask={true}
                              />
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    )}

                    {/* Always show Add Task button, but disable if closed */}
                    {!isSubtask && (
                      <ul className="border-l-2 pl-7 space-y-4 mt-3">
                        <li
                          className={`relative flex justify-between items-center border rounded-md px-1 py-2 transition 
                          ${
                            task.status === TASK_STATUS.CLOSED
                              ? "bg-gray-200 cursor-not-allowed opacity-70"
                              : "bg-white hover:bg-gray-50 cursor-pointer"
                          }`}
                          onClick={() => {
                            if (task.status !== TASK_STATUS.CLOSED) {
                              setIsModalOpen(task?.id);
                            }
                          }}
                        >
                          <span
                            className={`absolute -left-12 top-1 ${
                              task.status === TASK_STATUS.CLOSED
                                ? "bg-gray-300"
                                : "bg-gray-400"
                            } rounded-full py-1 px-1 border-4 border-white text-md text-white`}
                          >
                            <Plus size={25} />
                          </span>
                          <span
                            className={`text-center w-full flex justify-center items-center gap-2 ${
                              task.status === TASK_STATUS.CLOSED
                                ? "text-gray-500"
                                : "text-gray-900"
                            }`}
                          >
                            <Plus size={25} />{" "}
                            {task.status === TASK_STATUS.CLOSED
                              ? "Task closed"
                              : "Add custom task"}
                          </span>
                        </li>
                      </ul>
                    )}
                  </div>
                )}
              </li>
            )}
          </Draggable>
        ))}
      </ul>
    </div>
  );
};

export default SiteTaskCard;
